import Feedback from 'components/Form/Feedback';

import { CONTACT_EMAIL } from 'utils/constants';

export const SuccessMsg = ({ title, description, className }) => {
  return (
    <Feedback
      title={title}
      subtitle="Thank you"
      label="Take me home"
      href="/"
      bgRoundels={1}
      className={className}
    >
      {description}
    </Feedback>
  );
};

export const ErrorMsg = () => (
  <Feedback
    title="Uh oh..."
    subtitle="We're sorry"
    label="Take me home"
    href="/"
    bgRoundels={1}
  >
    We’re currently unable to handle this request. Please email{' '}
    <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> to complete your
    enquiry.
  </Feedback>
);
